/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const baseColumnsStokCihaz = [
  { Header: "Durum", accessor: "durum" },
  { Header: "IMEI", accessor: "imei" },
  { Header: "Model", accessor: "model" },
  { Header: "Protokol", accessor: "protokol" },
  { Header: "İş Ortağı", accessor: "is_ortagi" },
  { Header: "Alış Tarihi", accessor: "alis_tarihi" },
  { Header: "Tedarikçi", accessor: "tedarikci" },
  { Header: "Kira/Satış Tarihi", accessor: "kira_satis_tarihi" },
  { Header: "Plaka", accessor: "plaka" },
  { Header: "Firma", accessor: "firma" },
  { Header: "Not", accessor: "notlar" },
];

// Role göre kolonları filtrele - bayi rolünde "İş Ortağı" kolonunu gizle
export const getColumnsStokCihaz = (userRole) => {
  if (userRole === "bayi") {
    return baseColumnsStokCihaz.filter(col => col.accessor !== "is_ortagi");
  }
  return baseColumnsStokCihaz;
};

// Backward compatibility için default export
const columnsStokCihaz = baseColumnsStokCihaz;

export default columnsStokCihaz;
